module.exports = __webpack_public_path__ + "4a5041249dd5e7359c5f8e871e637a35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_22.jpg
// module id = 1669
// module chunks = 5